import APIClient from '../../../common/APIClient';
import { Cache } from 'aws-amplify';
import { displayError, ERROR_ALERT, setIsSaving, SUCCESS_ALERT, toggleShowAlert } from '../commonActions';

const FETCH_FOR_APPROVALS = 'FETCH_FOR_APPROVALS';
const ADD_PROJECT_REJECT_REMARKS = 'ADD_PROJECT_REJECT_REMARKS';

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
}

export const fetchForApprovals = () => {
  return (dispatch) => {
    client().get(
      '/projects/for-approval', {
        params: {
          user_id: Cache.getItem('userId')
        }
      }
    ).then(json => {
      const result = json.data;
      if (result) {
        let forApprovals = result.data;
        if (!forApprovals.length) {
          forApprovals = null;
        }

        dispatch({type: FETCH_FOR_APPROVALS, forApprovals});
      }
    }).catch(error => {
      dispatch(displayError(error));
    })
  }
}

export const approveProject = (projectId, successCallback = null, errorCallback = null) => {
  return (dispatch, getState) => {
    const user = getState().users.currentUser;
    const remarks = getState().projects.project.remarks;

    dispatch(setIsSaving(true));
    client().post(
      'projects/approve', {
        project_id: projectId, 
        approver_id: user.id,
        remarks 
      }
    ).then(json => {
      const result = json.data;
      if (result) {
        dispatch(setIsSaving(false));
        dispatch(toggleShowAlert(true, SUCCESS_ALERT, "Project has been successfully approved."));
        successCallback();
      }
    }).catch(error => {
      dispatch(displayError(error));
      dispatch(setIsSaving(false));
      errorCallback();
    })
  }
}

export const rejectProject = (projectId, successCallback = null, errorCallback = null) => {
  return (dispatch, getState) => {
    const user = getState().users.currentUser;
    const remarks = getState().projects.project.remarks;
    if (remarks) {
      client().post(
        'projects/reject', {
          project_id: projectId, 
          approver_id: user.id, 
          remarks
        }
      ).then(json => {
        const result = json.data;
        if (result) {
          dispatch(toggleShowAlert(true, SUCCESS_ALERT, "Project has been successfully rejected."));
          successCallback();
        }
      }).catch(error => {
        dispatch(displayError(error));
        errorCallback();
      })
    }
    else {
      dispatch(toggleShowAlert(true, ERROR_ALERT, "Please enter remarks."));
    }
  }
}

export const addRemarks = (e) => {
  return (dispatch) => {
    const remarks = {
      [e.target.id]:  e.target.value
    }

    dispatch({type: ADD_PROJECT_REJECT_REMARKS, remarks});
  }
}

